var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i", {
    staticClass: "moss-icon",
    domProps: { innerHTML: _vm._s(_vm.svgContent) }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }